import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Options } from '../../Models/options.model';
import { Industry, UserAdditionalInfo } from '../../Models/user-data.model';
import { CreditGeniusService } from '../../../Services/credit-genius.service';
import { numberOnly, toInteger } from '../../CommonUtility/util';
import { Router, RouterModule } from '@angular/router';
import { CommonHelperService } from '../../CommonUtility/common-helper.service';
import { PageType } from '../../Models/EnumHelper';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../../Components/navbar/navbar.component';
import { FooterComponent } from '../../Components/footer/footer.component';
import { FilterdataPipe } from "../../Extras/CustomPipes/filterdata.pipe";
@Component({
  selector: 'app-financial-details',
   standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NavbarComponent,
    FooterComponent,
    FilterdataPipe
],
  templateUrl: './financial-details.component.html',
  styleUrls: ['./financial-details.component.css']
})
export class FinancialDetailsComponent implements OnInit {
  imgSrc = environment.imgBasURL;
  navType:PageType = PageType.family
  FinancialForm!: FormGroup;
  CustomerId!: string;
  MaritalStatus: any;
  EmpStatus: any;
  filterd: string = "";
  isIndustry: boolean = false;
  selectedOption: Options;
  submitted = false;
  IsFinanceLoaded: boolean = false;
  validationMsgIndustry: boolean = false;
  validIndustry: boolean = false;
  IndustryList: Industry[] = [];
  options: Options[] = [
    { id: 1, name: '0', isSelect: true },
    { id: 2, name: '1', isSelect: false },
    { id: 3, name: '2', isSelect: false },
    { id: 4, name: '3+', isSelect: false }
  ]
  MaxAnnualSalary = 180000;

  constructor(
    private formBuilder: FormBuilder,
    private _creditGeniusService: CreditGeniusService,
    private router: Router,
    private _commonHelper: CommonHelperService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    
    if (isPlatformBrowser(this.platformId)) {
      this.CustomerId = sessionStorage.getItem('customer') || '';
    }
    this.selectedOption = this.options[0];
  }

  ngOnInit(): void {

    this.FinancialForm = this.formBuilder.group({
      MaritalStatus: ['', Validators.required],
      DependentNumber: [''],
      EmployeeStatus: ['', Validators.required],
      Industry: ['', Validators.required],
      AnnualSalary: ['0', Validators.required],
      Accommodation: ['0', Validators.required]
    });
    
    this.GetFinancialMasterData();
    //window.scrollTo(0, 0)
  }

  get f() {
    return this.FinancialForm.controls;
  }

  SelectDependent(optionid: number)
  {
    this.options.forEach((opt) => opt.id == optionid ? opt.isSelect = true : opt.isSelect = false);
    this.selectedOption = this.options.filter((item) => item.id == optionid)[0];
    this.selectedOption.isSelect = true;
  }

  GetFinancialMasterData(){
    this.MaritalStatus = [];
    this.EmpStatus = [];
    this.IndustryList = [];

    this._creditGeniusService.GetFinancialMasterData().subscribe((res: any) => {
      if (res != null  && res.data != null)
      {
        this.MaritalStatus = res.data.maritalStatus;
        this.EmpStatus = res.data.employmentStatus;
        this.IndustryList = res.data.industry;
      }
    },
    (err: HttpErrorResponse) => {
      console.log('Catch exception: ' + err);
    });
  }

  GetMaritalList() {
    this.MaritalStatus = [];
    this._creditGeniusService.GetMaritalStatus().subscribe((res: any) => {
      if (res != null  && res.data != null) {
        this.MaritalStatus = res.data;
      }
    },
    (err: HttpErrorResponse) => {
      console.log('Catch exception: ' + err);
    });
  }

  GetIndustryList() {
    this.IndustryList = [];
    this._creditGeniusService.GetIndustry().subscribe((res: any) => {
      if (res != null  && res.data != null) {
        this.IndustryList = res.data;
      }
    },
    (err: HttpErrorResponse) => {
      console.log('Catch exception: ' + err);
    });
  }

  GetEmployeeStatus() {
    this.EmpStatus = [];
    this._creditGeniusService.GetEmploymentStatus().subscribe((res: any) => {
      if (res != null  && res.data != null) {
        this.EmpStatus = res.data;
      }

    },
    (err: HttpErrorResponse) => {
      console.log('Catch exception: ' + err);
    });
  }

  filterByindustry(e:any): void {
    this.filterd = e.target.value;
  }
  industryclick() {
    this.isIndustry = true;
  }

  Industryselection(selecteValue: any) {
    this.f['Industry'].setValue(selecteValue.industryName);
  }

  applyValidations(event: any) {

    let _this = this;
    let targetName = event.target.name;

    if (targetName == 'Industry') {

      setTimeout(function () {
          let targetValue = _this.f['Industry'].value;
          if(targetValue == ''){
            _this.validationMsgIndustry = true;
            _this.validIndustry = false;
          }
          else{
            _this.validationMsgIndustry = false;
            let objIndustry = _this.IndustryList.find(o => o.industryName === targetValue);
            if (objIndustry) {
              _this.validIndustry = false;
            }
            else{
              _this.validIndustry = true;
              _this.f['Industry'].patchValue('');
            }
          }
        _this.isIndustry = false;
      }, 300);
    }
    else if (targetName == 'AnnualSalary') {
     
       if (this.f['AnnualSalary'].value == ''||this.f['AnnualSalary'].value == '0') {
        this.f['AnnualSalary'].patchValue('0');
        }
      else {
        if(event.target.value > this.MaxAnnualSalary)
        {
          this.f['AnnualSalary'].setErrors({ 'incorrect': true });
        }
        else{
          this.f['AnnualSalary'].patchValue(this.f['AnnualSalary'].value.replace(/^0+/, ''));
        }
       
      }
    }
    else if (targetName == 'Accommodation') {
     
       if (this.f['Accommodation'].value == ''||this.f['Accommodation'].value == '0') {
        this.f['Accommodation'].patchValue('0');
        }
      else {
        this.f['Accommodation'].patchValue(this.f['Accommodation'].value.replace(/^0+/, ''));
      }
    }
  }

  NumberOnly(event:any): boolean {
    let _this = this;
    var s =numberOnly(event)
    if (event.target.name == 'AnnualSalary') {
    if( _this.f['AnnualSalary'].value === '0'){
        _this.f['AnnualSalary'].patchValue('');
      }
    }
    if (event.target.name == 'Accommodation') {
      if( _this.f['Accommodation'].value === '0'){
          _this.f['Accommodation'].patchValue('');
        }
      }
   
    return s;
  }

  onSubmit()
  {
    this.router.navigate(['/result']); // TODO: remove this line after testing
    this.submitted = true;
    this.IsFinanceLoaded = true;

    if (this.FinancialForm.invalid) {
      this.IsFinanceLoaded = false;
      return;
    }
    else{
      let objIndustry = this.IndustryList.find(o => o.industryName === this.f['Industry'].value);
      if (!objIndustry) {
      this.IsFinanceLoaded = false;
      return;
  }

      const data: UserAdditionalInfo = {
        CustomerId: this.CustomerId,
        MaritalStatus: Number(this.f['MaritalStatus'].value),
        No_of_Dependents: this.selectedOption.name,
        EmploymentStatus: Number(this.f['EmployeeStatus'].value),
        IndustryId: objIndustry.industryId,
        AnnualSalary: Number(this.f['AnnualSalary'].value),
        AccommodationCost: Number(this.f['Accommodation'].value),
      };

      this._creditGeniusService.SaveUserAdditionalInfo(data).subscribe((res)=>{

        this.IsFinanceLoaded = false;
       

        if (sessionStorage.getItem('stepnumbers') !== null){
          sessionStorage.removeItem('stepnumbers');
        }
        this.router.navigate(['/result']);
      },(error)=>{

        this.IsFinanceLoaded=false;
        console.log(error);
      });
    }

  }

}
